import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { Alert, Button, Table } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Studies from '../store/Studies';
import * as StudySites from '../store/StudySites';
import * as utility from '../data/Utility';
import * as sortfilter from '../data/SortFilter';


class ManageStudiesInternal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
			isShowingFilter: false,
			currentFilters: {},
			currentSortDirection: {},
			currentSortingColumn: '',
            allFetched: false
        }
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
		this.props.studiesDispatch.set(null);
        this.initialize(null);
    }

    componentDidUpdate(prevProps) {
        this.initialize(prevProps);
    }

    handleStudySelected(id, sponsorId) {
        const history = this.props.history;
        if (history.location.pathname === paths.manageStudies) {
            history.push({
                pathname: paths.study,
                state: {
                    create: false,
                    editing: false,
                    sponsorId: sponsorId,
                    studyId: id
                }
            });
        }
    }

    initialize(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAdministrator(accountsState);
        if (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching, !this.state.allFetched)) {
            this.props.studiesDispatch.getAll();
            this.props.studySitesDispatch.getAll();
            this.setState({
                allFetched: true
            });
        }
    }

	onSortChange = (currentColumn) => {
		let currentSortDirection = this.state.currentSortDirection;
		let nextSort = 'default';

		switch ( currentSortDirection[currentColumn] ) {
			case "down": nextSort = 'default'; break;
			case "up"  : nextSort = 'down'; break;
			default    : nextSort = 'up'; break;
		}

		let newCurrentSortDirection = {};
		newCurrentSortDirection[currentColumn] = nextSort;

		this.setState({
			currentSortDirection: newCurrentSortDirection,
			currentSortingColumn: currentColumn,
		});
	};

	onFilterChange = (e) => {
		this.setState({ currentFilters: {...this.state.currentFilters, [e.target.name]: e.target.value } });
	};


	ColumnHeader = (props) => {
		sortfilter.filterAssociation[props.recordKey] = props.label;
		let val = this.state.currentFilters[props.label];
		if ( val === undefined ) {
			val = '';
		}
		return <sortfilter.ColHeader value={val} onChange={this.onFilterChange.bind(this)} sortDir={this.state.currentSortDirection} onSortChange={this.onSortChange} showFilter={this.state.isShowingFilter} label={props.label} recordKey={props.recordKey} />
	};


	/* If any patients have been added to this study, then this should return false, otherwise true. */
	isEditingAllowed(studyId) {
		if ( studyId == null ) {
			return false;
		}
		const allStudies = this.props.studiesState && this.props.studiesState.all;
		const thisStudy = allStudies.find( function (s) { return s.id === studyId } );

		return ! thisStudy.isLocked;
	}


    render() {
        if (!Accounts.authenticatedAdministrator(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        var error = false;
        var message = "";
        var studyList = null;

        const studies = this.props.studiesState.all;
        const studySites = this.props.studySitesState.all;
        if (studies != null &&
            studies.map != null &&
            studySites != null &&
            studySites.forEach != null) {
            const editTitle = "Edit";
            var rowNum = 1;
            var siteList = null;

            let sList = [...studies].map(study => {
                siteList = [];
                studySites.forEach(studySite => {
                    if (studySite.study.id === study.id) {
                        siteList.push(studySite.site);
                    }
                });
                const siteNames = utility.getNamesFromArray(siteList);

				return ({ ...study,
					siteNames: siteNames
				});

            });
			sList = sortfilter.filterData( sList, this.state.currentFilters );

            studyList = [...sList].sort( sortfilter.sortingDetails(this.state.currentSortingColumn,this.state.currentSortDirection).fn ).map(study => {

                return (
                    <tr key={study.id} onClick={this.handleStudySelected.bind(this, study.id, study.sponsorId)}>
                        <th scope="row">{rowNum++}</th>
                        <td>{study.name}</td>
                        <td>{study.code}</td>
                        <td>{study.siteNames}</td>
                        <td>
							{ this.isEditingAllowed(study.id) &&
                            <Button className="button-inverse" title={editTitle} tag={Link} to={{ pathname: paths.study, state: { create: false, sponsorId: study.sponsorId, studyId: study.id } }}>{editTitle}</Button>
							}
                        </td>
                    </tr>
                );
            });
        }
        else {
            error = true;
            message = "Error retrieving studies.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        return (
            <div>
                <h1>Manage Studies</h1>
                <Button className="button filter_button" id="btnFilter" title="Filter" onClick={sortfilter.toggleFilter.bind(this)}> Filter </Button>
                <br />
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                <Table striped hover>
                    <thead>
                        <tr>
                            <th>#</th>
							<this.ColumnHeader label="Name" recordKey="name" />
							<this.ColumnHeader label="Code" recordKey="code" />
							<this.ColumnHeader label="Sites" recordKey="siteNames" />
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {studyList}
                    </tbody>
                </Table>
            </div>
        );
    }
}

const ManageStudiesConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts,
        studiesState: state.studies,
        studySitesState: state.studySites
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        studiesDispatch: bindActionCreators(Studies.actionCreators, dispatch),
        studySitesDispatch: bindActionCreators(StudySites.actionCreators, dispatch)
    })
)(ManageStudiesInternal));

export default class ManageStudies extends React.Component {
    render() {
        return (
            <ErrorBoundary>
                <ManageStudiesConnect />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ManageStudies.js